import React, { useMemo } from "react";
import Typography from "@mui/material/Typography";
import { useQuery } from "@apollo/client/react";
import sortBy from "lodash/sortBy";
import { useAssetsVariables } from "../../contexts/assets-variables";
import useQueryParams from "../../hooks/useQueryParams";
import { WAREHOUSE_NAMES } from "../../constants/graphql/queries";

const label = {
  showOutOfWarehouse: "Out of Warehouse",
  showOnlyInStockItems: "In-Stock Inventory",
  showAllInventory: "All Inventory",
};

export default function ViewingStatus({ variables, project }) {
  const { selectedWarehouseId } = useAssetsVariables();
  const searchParams = useQueryParams();
  const warehouseId = searchParams.get("warehouseId") || selectedWarehouseId;

  const { data: { warehouses: allWarehouses = [] } = {} } = useQuery(WAREHOUSE_NAMES, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-first",
    variables: { userWarehouses: true },
    skip: project?.warehouses?.length > 0,
  });

  const warehouses = useMemo(() => {
    if (project?.warehouses?.length > 0) {
      return project.warehouses;
    }
    return sortBy(
      allWarehouses.map(({ warehouseId, name }) => ({ warehouseId, name })),
      "name"
    );
  }, [project?.warehouses, allWarehouses]);

  const warehouseName = warehouses?.find(w => w.warehouseId === warehouseId)?.name;

  const selected = variables.showDeployedAssets
    ? "showOutOfWarehouse"
    : variables.hideDepletedAssets
    ? "showOnlyInStockItems"
    : "showAllInventory";

  return (
    <Typography fontSize={14} color="text.primary">
      Viewing {label[selected]} {warehouseName && warehouseId !== "all"
        ? ` Within ${warehouseName}`
        : " Across All Warehouses"
      }
    </Typography>
  );
}
